import {useEffect, useState} from 'react';
import {subscribeToReviewerQueue} from '../../../../../firebase/firestore/reports';

/**
 * Custom hook to load the reviewer queue: pending ("Awaiting Review") rows
 * first, then approved rows sorted by newest-first within each group.
 */
export const useReports = (userId) => {
    const [loading, setLoading] = useState(true);
    const [reports, setReports] = useState([]);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!userId) {
            setLoading(false);
            return;
        }

        setLoading(true);
        setError(null);

        const unsubscribe = subscribeToReviewerQueue(
            (data) => {
                setReports(data);
                setLoading(false);
            },
            (err) => {
                console.error('Failed to load reviewer queue', err);
                setError(err);
                setLoading(false);
            }
        );

        return () => {
            try {
                unsubscribe?.();
            } catch (e) {
                // noop
            }
        };
    }, [userId]);

    return {reports, loading, error};
};
